import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { VariableDto2 } from "app/ApiClient";
import { getProjectHeatmapSettings } from "slices/projectHeatmapSettings/projectHeatmapSettingsSlice";

export interface SelectedWeightingVariableState {
  weightingVariable: VariableDto2 | null;
  isWeightingEnabled: boolean;
}

const initialState = {
  weightingVariable: null,
  isWeightingEnabled: false,
} as SelectedWeightingVariableState;

const selectedWeightingVariableSlice = createSlice({
  name: "selectedWeightingVariable",
  initialState: initialState,
  reducers: {
    resetSelectedWeightingVariable: () => initialState,
    setWeightingVariable: (state, action: PayloadAction<VariableDto2>) => {
      state.weightingVariable = action.payload;
    },
    setIsWeightingEnabled: (state, action: PayloadAction<boolean>) => {
      state.isWeightingEnabled = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getProjectHeatmapSettings.fulfilled, (state, action) => {
      const { selectedWeightingVariable } = action.payload.projectSettings;
      return selectedWeightingVariable ?? initialState;
    });
  },
});

export const { setWeightingVariable, setIsWeightingEnabled, resetSelectedWeightingVariable } =
  selectedWeightingVariableSlice.actions;

export default selectedWeightingVariableSlice.reducer;
